function encodeBase64(data) {
  // eslint-disable-next-line no-undef
  return Buffer.from(JSON.stringify(data)).toString('base64');
}

function encodeBase64WithoutStringify(data) {
  // eslint-disable-next-line no-undef
  return Buffer.from(data).toString('base64');
}

function decodeBase64(data) {
  try {
    // eslint-disable-next-line no-undef
    return JSON.parse(Buffer.from(data, 'base64').toString('utf-8'));
  } catch (error) {
    return false;
  }
}

export { encodeBase64, decodeBase64, encodeBase64WithoutStringify };
